export default __webpack_public_path__ + "static/media/american-express.d48d1beb.png";